// extracted by mini-css-extract-plugin
module.exports = {"title":"ReviewInfo_title__1-AkX","heading":"ReviewInfo_heading__Yabmk","info":"ReviewInfo_info__20fVB"};